import { Box } from '@chakra-ui/react';
import React from 'react';

import type { RoutingContextData } from '../../interface/routingContext';
import type { SlotProps } from '../../interface/slotProps';
import {
  INK,
  ROUTING_CONTEXT_COLORS,
  ROUTING_CONTEXT_FONT_SIZE,
  ROUTING_CONTEXT_FONT_WEIGHT,
  ROUTING_CONTEXT_LETTER_SPACING
} from '../../styles/tokens';
import { Chip } from '../Chip';

const PLACEHOLDER = 'N/A';

export const RoutingContext: React.FC<SlotProps> = ({ value }) => {
  const data: RoutingContextData =
    value != null && typeof value === 'object' && !Array.isArray(value)
      ? (value as RoutingContextData)
      : {};
  const reason =
    typeof data.reason === 'string' && data.reason.trim() !== ''
      ? data.reason.trim()
      : undefined;

  if (reason === undefined) {
    return (
      <Box as="span" data-testid="routing-context" color={INK}>
        {PLACEHOLDER}
      </Box>
    );
  }

  return (
    <Chip
      testId="routing-context"
      ariaLabel={`Routing context: ${reason}`}
      borderColor={ROUTING_CONTEXT_COLORS.border}
      bgImage="none"
      bg={ROUTING_CONTEXT_COLORS.bg}
      paddingLeft="9px"
      fontFamily="inherit"
      _hover={{
        borderColor: ROUTING_CONTEXT_COLORS.border,
        bg: ROUTING_CONTEXT_COLORS.bg
      }}
    >
      <Box
        as="span"
        aria-hidden
        data-testid="routing-context-dot"
        w="6px"
        h="6px"
        flexShrink={0}
        borderRadius="50%"
        bg={ROUTING_CONTEXT_COLORS.fg}
      />
      <Box
        as="span"
        data-testid="routing-context-reason"
        color={ROUTING_CONTEXT_COLORS.fg}
        fontSize={ROUTING_CONTEXT_FONT_SIZE}
        fontWeight={ROUTING_CONTEXT_FONT_WEIGHT}
        letterSpacing={ROUTING_CONTEXT_LETTER_SPACING}
        whiteSpace="nowrap"
      >
        {reason}
      </Box>
    </Chip>
  );
};
